import React, { Component } from 'react'
import PropTypes from 'prop-types';

export class TodoItem extends Component {

  getStyle = () => {
    return {
        background: "#f4f4f4",
        padding: "10px",
        borderBottom: "2px #ccc dotted",
        textDecoration: this.props.todo.completed ? "line-through" : "none"
    };
  };
    
  render() {

    const {id, title} = this.props.todo;

    return (
      <div style={this.getStyle()}>
        <p>
            <input type='checkbox' onChange={this.props.markComplete.bind(this, id)}/> { "" }
            {title}
            <button style={btnStyle} onClick={this.props.delTodo.bind(this, id)}>x
            </button>
        </p>
      </div>
    );
  }
}

//proptypes
TodoItem.propTypes = {
    todo: PropTypes.object.isRequired
};

const btnStyle = {
  background: "crimson",
  color: "#f3f3f3",
  border: "none",
  padding: "5px 10px",
  borderRadius: "50%",
  cursor: "pointer",
  float: "right"
};

export default TodoItem;
